import { tokens } from '../tokens';

export const es = {
  [tokens.common.languageChanged]: 'Se ha cambiado el idioma',
  [tokens.nav.account]: 'Cuenta',
  [tokens.nav.analytics]: 'Analítica',
  [tokens.nav.auth]: 'Autenticación',
  [tokens.nav.concepts]: 'Conceptos',
  [tokens.nav.users]: 'Usuarios',
  [tokens.nav.dashboard]: 'Dashboard',
  [tokens.nav.forgotPassword]: 'Recuperar Contraseña',
  [tokens.nav.login]: 'Acceso',
  [tokens.nav.profile]: 'Perfil',
  [tokens.nav.register]: 'Registrarse',
  [tokens.nav.resetPassword]: 'Restablecer Contraseña',
  [tokens.nav.verifyCode]: 'Verificar Código',
  [tokens.nav.summary]: 'Resumen',
  [tokens.nav.seace]: 'SEACE',
  [tokens.nav.mivivienda]: 'FONDO MIVIVIENDA',
  [tokens.nav.operaciones]: 'Operaciones',
  [tokens.nav.tablero]: 'Tablero',
  [tokens.nav.inversionistas]: 'Inversionistas',
  [tokens.nav.pymes]: 'PYMEs',
  [tokens.nav.honorarios]: 'Honorarios',
  [tokens.nav.cierre]: 'Cierre',
  [tokens.nav.archivos]: 'Gestión de Archivos',
  [tokens.nav.comunicaciones]: 'Comunicaciones',
  [tokens.nav.estructuracion]: 'Revisión de Solicitudes',
  [tokens.nav.llamadoCapital]: 'Llamado de Capital',
  [tokens.nav.seguimiento]: 'Seguimiento de Operaciones',
  [tokens.nav.fiduciaria]: 'Fiduciaria',
  [tokens.nav.tiposInversion]: 'Tipos de Inversión',
  [tokens.nav.configuracion]: 'Configuración de Costos',
  [tokens.nav.misInversiones]: 'Mis Inversiones',
  [tokens.nav.invDashboard]: 'Dashboard',
  [tokens.nav.panel]: 'Panel',
  [tokens.nav.oportunidades]: 'Oportunidades',
  [tokens.nav.misInversionesDetail]: 'Mis Inversiones',
  [tokens.nav.inversionesActivas]: 'Inversiones Activas',
  [tokens.nav.estadoCuenta]: 'Estado de Cuenta',
  [tokens.nav.historial]: 'Historial',
  [tokens.nav.miPyme]: 'Mi PYME',
  [tokens.nav.pymeDashboard]: 'Dashboard',
  [tokens.nav.solicitar]: 'Solicitar Financiamiento',
  [tokens.nav.cotizador]: 'Cotizador',
  [tokens.nav.cronograma]: 'Cronograma de Pagos',
  [tokens.nav.facturacion]: 'Cuenta por Cobrar',
  [tokens.nav.contrato]: 'Contrato / Liquidación',
  [tokens.nav.alertas]: 'Alertas de Pago',
};
